import { Injectable, inject } from "@angular/core";
import { Constants } from "@config/constants";
import { HttpService } from "@services/http.service";
import { Observable, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SignDownloadService {
  private _httpService = inject(HttpService);

  downloadSignedFile$(signRequestId: string): Observable<unknown> {
    const requestId = signRequestId?.trim();
    if (!requestId) {
      return throwError(() => new Error("SIGN_REQUEST_ID_REQUIRED"));
    }

    return this._httpService.post(
      this._httpService.createEndpoint(
        Constants.API_URI_SIGN_DOWNLOAD_SIGNED_FILE,
      ),
      {
        signRequestId: requestId,
      },
    );
  }
}
